'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopPage = exports.mapDispatchToProps = exports.asyncProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _class, _temp; // Top

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';
// programmatically pushes a new location to history, uncomment if needed
// import { push } from 'react-router-redux';

// api

// containers
// eslint-disable-line import/no-named-default
// components

// action creators


exports.mapStateToProps = mapStateToProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _trvFedApiClient = require('../trv-fed-api-client.js');

var _trvFedApiClient2 = _interopRequireDefault(_trvFedApiClient);

var _HotelSearchBox = require('./HotelSearchBox');

var _HotelSearchBox2 = _interopRequireDefault(_HotelSearchBox);

var _Signature = require('../components/Signature');

var _Signature2 = _interopRequireDefault(_Signature);

var _Explanations = require('../components/Explanations');

var _Explanations2 = _interopRequireDefault(_Explanations);

var _Notification = require('../components/Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _Tiles = require('../components/Tiles');

var _Tiles2 = _interopRequireDefault(_Tiles);

var _Recommendations = require('../components/Recommendations');

var _Recommendations2 = _interopRequireDefault(_Recommendations);

var _explanations = require('../modules/explanations');

var _notifications = require('../modules/notifications');

var _recommendations = require('../modules/recommendations');

var _signatures = require('../modules/signatures');

var _topDestinations = require('../modules/topDestinations');

var _features = require('../modules/features');

var _search = require('../modules/search');

var _breadcrumbs = require('../modules/breadcrumbs');

var _query = require('../helpers/query');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/makeomatic/redux-connect/blob/master/docs/API.MD
var asyncProps = exports.asyncProps = [{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        location = _ref.location,
        params = _ref.params;

    var state = getState();
    var promises = [];
    var urls = state.urls;


    dispatch((0, _breadcrumbs.clear)());

    promises.push((0, _trvFedApiClient2.default)(urls.api.signatures.replace(':countryID', 'World'), 'GET', {}, state.httpRequest.req, {
      maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
      timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
    }, 3000).then(function (res) {
      return dispatch((0, _signatures.set)(res));
    }, function (res) {
      dispatch((0, _signatures.clear)());
      // Should not throw exception
      // Even if error has been occurred, service should be available
      console.error(res);
    }));

    if (!state.explanations.title) {
      promises.push((0, _trvFedApiClient2.default)(urls.api.explanations, 'GET', {}, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 3000).then(function (res) {
        return dispatch((0, _explanations.set)(res));
      }, function (res) {
        // Should not throw exception
        // Even if error has been occurred, service should be available
        console.error(res);
      }));
    }

    promises.push((0, _trvFedApiClient2.default)(urls.api.notifications, 'GET', {}, state.httpRequest.req, {
      maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
      timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
    }, 2000).then(function (res) {
      return dispatch((0, _notifications.set)(res));
    }, function (res) {
      // Should not throw exception
      // Even if error has been occurred, service should be available
      console.error(res);
    }));

    promises.push((0, _trvFedApiClient2.default)(urls.api.topDestinations.replace(':countryID', 'World'), 'GET', {}, state.httpRequest.req, {
      maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
      timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
    }, 3000).then(function (res) {
      return dispatch((0, _topDestinations.set)(res));
    }, function (res) {
      // Should not throw exception
      // Even if error has been occurred, service should be available
      console.error(res);
      dispatch((0, _topDestinations.clear)());
    }));

    promises.push((0, _trvFedApiClient2.default)(urls.api.features, 'GET', {}, state.httpRequest.req, {
      maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
      timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
    }, 3000).then(function (res) {
      return dispatch((0, _features.set)(res));
    }, function (res) {
      // Should not throw exception
      // Even if error has been occurred, service should be available
      console.error(res);
      dispatch((0, _features.clear)());
    }));

    if (!state.recommendations.length) {
      promises.push((0, _trvFedApiClient2.default)(urls.api.recommendations, 'GET', {}, state.httpRequest.req, {
        maintenance: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater },
        timeout: { title: state.i18n.errors.serviceUnavailable, message: state.i18n.errors.pleaseTryAgainLater }
      }, 2000).then(function (res) {
        return dispatch((0, _recommendations.set)(res));
      }, function (res) {
        // Should not throw exception
        // Even if error has been occurred, service should be available
        console.error(res);
      }));
    }

    if ((0, _keys2.default)(location.query).length) {
      dispatch((0, _search.update)((0, _query.convertLocationToState)(location.query, params).search));
    } else {
      dispatch((0, _search.clear)());
    }

    return _promise2.default.all(promises);
  }
}];

// mapStateToprops can be either an object or a funciton
function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    urls: state.urls,
    explanations: state.explanations,
    notifications: state.notifications,
    recommendations: state.recommendations,
    signatures: state.signatures,
    topDestinations: state.topDestinations,
    features: state.features,
    isMobile: state.httpRequest.req.useragent.isMobile
  };
}

// mapDispatchToprops can be either an object or a funciton
var mapDispatchToProps = exports.mapDispatchToProps = {
  push: _reactRouterRedux.push
};

// eslint-disable-next-line react/prefer-stateless-function
var TopPage = exports.TopPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TopPage, _Component);

  function TopPage() {
    (0, _classCallCheck3.default)(this, TopPage);
    return (0, _possibleConstructorReturn3.default)(this, (TopPage.__proto__ || (0, _getPrototypeOf2.default)(TopPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(TopPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          i18n = _props.i18n,
          urls = _props.urls,
          explanations = _props.explanations,
          notifications = _props.notifications,
          recommendations = _props.recommendations,
          signatures = _props.signatures,
          topDestinations = _props.topDestinations,
          features = _props.features,
          isMobile = _props.isMobile;

      return _react2.default.createElement(
        'div',
        { id: 'content', className: 'area-layout01-wide layout-fluid' },
        _react2.default.createElement(
          'div',
          { className: 'nav-secondary' },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              { className: 'select' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: urls.app.root },
                i18n.header.hotels
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: urls.external.cars },
                i18n.header.cars
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: urls.external.campaign },
                i18n.header.features
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: urls.external.activities },
                i18n.header.thingsToDo
              )
            )
          )
        ),
        _react2.default.createElement(
          _Signature2.default,
          { i18n: i18n, items: signatures, hideDetails: true },
          _react2.default.createElement(_HotelSearchBox2.default, { hideDetails: true, display: 'form' })
        ),
        explanations.items && explanations.items.length ? _react2.default.createElement(_Explanations2.default, { explanations: explanations }) : null,
        notifications.length ? _react2.default.createElement(
          'div',
          { className: 'notification-box' },
          notifications.map(function (notification, index) {
            return (
              // eslint-disable-next-line react/no-array-index-key
              _react2.default.createElement(_Notification2.default, { key: index, i18n: i18n, notification: notification })
            );
          })
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'area' },
          topDestinations.length ? _react2.default.createElement(_Tiles2.default, { title: i18n.top.moreToExplore,
            showMore: i18n.ellipsis.showMore,
            showLess: i18n.ellipsis.showLess,
            items: topDestinations,
            urls: urls,
            openLinkInNewTab: false
          }) : null,
          recommendations.length ? _react2.default.createElement(_Recommendations2.default, {
            i18n: i18n,
            items: recommendations,
            urls: urls
          }) : null,
          !isMobile && features.length ? _react2.default.createElement(_Tiles2.default, { title: i18n.top.features,
            showMore: i18n.ellipsis.showMore,
            showLess: i18n.ellipsis.showLess,
            items: features,
            urls: urls
          }) : null
        )
      );
    }
  }]);
  return TopPage;
}(_react.Component), _class.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired,
  explanations: _react.PropTypes.object.isRequired,
  notifications: _react.PropTypes.array.isRequired,
  recommendations: _react.PropTypes.array.isRequired,
  signatures: _react.PropTypes.array.isRequired,
  topDestinations: _react.PropTypes.array.isRequired,
  features: _react.PropTypes.array.isRequired,
  isMobile: _react.PropTypes.bool.isRequired
}, _temp);


var asyncConnectedTop = (0, _reduxConnect.asyncConnect)(asyncProps)(TopPage);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(asyncConnectedTop);


//////////////////
// WEBPACK FOOTER
// ./src/containers/TopPage.js
// module id = 1242
// module chunks = 0